/**
 * Function used to send post requests into Scratch to perform different tasks
 * @param scratchIframeRef - Reference to the <iframe/> element that holds the Scratch GUI.
 * @param type - Type of action to perform.
 * @param content - (Optional) Object to attach into the request.
 */
export const postScratchRequest = (
  scratchIframeRef: React.MutableRefObject<HTMLIFrameElement | null>,
  type:
    | "GET_JSON"
    | "DOWNLOAD_PROJECT"
    | "SAVE_PROJECT"
    | "LOAD_PROJECT"
    | "TOGGLE_TURBO_MODE"
    | "RESTORE_DEFAULT_SPRITE"
    | "CHANGE_THEME"
    | "SET_SAVE_STATUS",
  content: object = {}
) => {
  const iframe = scratchIframeRef.current;
  if (iframe && iframe.contentWindow) {
    iframe.contentWindow.postMessage({ type: type, ...content }, "*");
  }
};
